/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class BuildingDataServiceEndpoints {
  /**
   *
   * @returns Endpoint to query FittingData.
   */
  static PostFittingDataByQueryUrl = (): string => {
    return `FittingData/Query`;
  };

  /**
   *
   * @param id
   * @returns Endpoint to query FittingData by fitting entry id.
   */
  static GetFittingDataByFittingEntryId = (id: number) => {
    return `FittingData/fittingentryid/${id}`;
  };
}
